import React, { useState, useEffect } from "react";
import ExtendedCheckbox from "@src/stories/elements/ExtendedCheckbox/ExtendedCheckbox";

const ExtendedProductMonogram = ({ props }) => {
  const {
    text_font_1,
    text_font_2,
    text_label_1,
    text_label_2,
    show_second,
    font_property_name = 'monogram-font',
    is_messaging = false,
    heading_text_1,
    description_text_1 = 'Step 2 Enter Your Monogram',
    placeholder_text_1,
    max_characters_1 = 20,
    heading_text_2,
    description_text_2 = 'Step 3 Enter Your Monogram',
    placeholder_text_2,
    max_characters_2 = 20,
    block_words,
    no_monogram_required_label
  } = props?.settings?.block_settings;

  const { required_monogram = false } = props?.settings;

  const text_property_name_1 = is_messaging ? 'Messaging' : 'monogram-text-1';
  const text_property_name_2 = is_messaging ? 'Messaging' : 'monogram-text-2';


  let options = [
    {
      type: text_label_1,
      font: text_font_1
    },
    {
      type: text_label_2,
      font: text_font_2
    }
  ].filter(opt => opt.type && opt.font)

  const [ currentOption, setCurrenOption] = useState(options[0].type)
  const [ noMonogram, setnoMonogram] = useState(false)
  const [ monogram1, setMonogram1 ] = useState('');
  const [ monogram2, setMonogram2 ] = useState('');

  function filterBannedWords(text) {
    if (!block_words) return text;

    const bannedArray = block_words.split(",").map((item) => item.trim().toLowerCase());

    return text.split(" ").filter((word) => {
      return !bannedArray.some((bannedWord) =>
        word.toLowerCase().includes(bannedWord)
      );
    }).join(" ");
  }

 useEffect(() => {
    if (noMonogram ) {
      setMonogram1('N/A');
      setMonogram2('N/A');
    }
  }, [noMonogram]);

  return (
    <div className={'product-monogram flex flex-col'}>
        {!is_messaging &&
          <div className={`flex flex-col gap-2`}> 
            <div className={`text-[14px]`}> 
                {`Step 1 Select Font`}
            </div>

            
              <input
                  type="text"
                  data-name={`${font_property_name}`}
                  name={`properties[${font_property_name}]`}
                  id={`line-item-${font_property_name}`}
                  value={noMonogram || ( monogram1 == ''  && monogram2 == '') ? 'N/A' : currentOption}
                  readOnly 
                  className="product-monogram__input line-item-property hidden"
              />
            
      
            <div className="flex flex-row w-100 gap-2"> 
              {options.map((option) => (
                <div
                  key={option?.type}
                  style={{ fontFamily: option.font }}
                  className={`product-monogram__option !w-1/2 button ${option.type == currentOption ? `button-primary`: `button-secondary !font-[500]` } `}
                  onClick={()=> setCurrenOption(option.type)}
                > 
                  {option.type}
                </div>
              ))}
            </div>

          </div>
        } 

        <div className={`flex flex-col gap-4`}>
          <div className=" flex flex-col gap-2">
            {heading_text_1 &&
              <div className={`font-bold`}> 
                {heading_text_1}
              </div> 
            }

            <div className={`text-[14px]`}> 
              {description_text_1}
            </div> 

            <input
              type="hidden"
              data-name={text_property_name_1}
              name={`properties[${text_property_name_1}]`}
              value={noMonogram || monogram1 == '' ? 'N/A' : monogram1}
              
              readOnly
              className="line-item-property"
            />

            <textarea
              data-name={text_property_name_1}
              name={`visible_${text_property_name_1}`}
              id={`line-item-${text_property_name_1}`}
              placeholder={placeholder_text_1}
              value={noMonogram ? 'N/A' : monogram1}
              disabled={noMonogram} 
              maxLength={max_characters_1 === 0  ?  null : max_characters_1}
              onChange={e => setMonogram1(filterBannedWords(e.target.value))}
              className={`product-monogram__input  ${noMonogram || monogram1 == '' ? '' : 'line-item-property'}`}
            />

            {(max_characters_1 !== 0 && !noMonogram) && (
              <div className="flex justify-end text-[12px] font-[300]">
                {`${max_characters_1 - monogram1.length} Character(s) Left`}  
              </div>
            )}
          </div>

          {show_second && 
            <div className="flex flex-col gap-2">
              {heading_text_2 &&
                <div className={`font-bold`}> 
                  {heading_text_2}
                </div> 
              }

              <div className={`text-[14px]`}> 
                {description_text_2}
              </div> 

              <input
                type="hidden"
                data-name={text_property_name_2}
                name={`properties[${text_property_name_2}]`}
                value={noMonogram || monogram2 == '' ? 'N/A' : monogram2}
                readOnly
                className="line-item-property"
              />
              
              <textarea
                data-name={text_property_name_2}
                name={`visible_${text_property_name_2}`}
                id={`line-item-${text_property_name_2}`}
                value={noMonogram ? 'N/A'  : monogram2}
                disabled={noMonogram} 
                placeholder={placeholder_text_2}
                maxLength={max_characters_2 === 0 ?  null : max_characters_2}
                onChange={e => setMonogram2(filterBannedWords(e.target.value))}
                className={`product-monogram__input  ${noMonogram ? '' : 'line-item-property'}`}
              />

              {(max_characters_2 !== 0 && !noMonogram) && (
                <div className="flex justify-end text-[12px] font-[300]">
                  {`${max_characters_2 - monogram2.length} Character(s) Left`}  
                </div>
              )}
            </div>
          }
        </div>
  
        {!required_monogram &&
          <div className="flex justify-center"> 
              <ExtendedCheckbox                     
                  name={'no_monogram'}
                  label={no_monogram_required_label}
                  checked={noMonogram}
                  onChange={()=> { setnoMonogram(!noMonogram); setMonogram1(''); setMonogram2(''); }}
              />
          </div>
        }
    </div>
  )
}

export default ExtendedProductMonogram;